import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {OrderHistoryActions} from './order-history.actions';
import {catchError, map, of, switchMap, tap, withLatestFrom} from 'rxjs';
import {OrderApiService} from '../../data/order-api.service';
import {ErrorActions} from 'app/core/components/error-page/state/error.actions';
import {Router} from '@angular/router';
import {selectPagination} from './order-history.reducer';
import {Store} from '@ngrx/store';
import {PaginationParameters} from 'app/models/pagination-parameters';

@Injectable()
export class OrderHistoryEffects {
  loadOrders$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrderHistoryActions.loadOrders),
      switchMap(({params}) =>
        this.orderHistoryApi.list(params).pipe(
          map(response => OrderHistoryActions.loadOrdersSuccess({ordersPage: response})),
          catchError(error => of(OrderHistoryActions.loadOrdersFailure({error})))
        )
      )
    )
  );

  searchOrders$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(OrderHistoryActions.searchOrders),
        withLatestFrom(this.store.select(selectPagination)),
        tap(([__props, paginationParams]) => {
          this.reloadOrders(paginationParams);
        })
      ),
    {dispatch: false}
  );

  loadOrdersFailure$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrderHistoryActions.loadOrdersFailure),
      map(({error}) => ErrorActions.directToErrorPage({error}))
    )
  );

  goToNextPage$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(OrderHistoryActions.goToPage),
        withLatestFrom(this.store.select(selectPagination)),
        tap(([__props, paginationParams]) => {
          this.reloadOrders(paginationParams);
        })
      ),
    {dispatch: false}
  );

  constructor(
    private actions$: Actions,
    private orderHistoryApi: OrderApiService,
    private store: Store,
    private router: Router
  ) {}

  private reloadOrders(paginationParams: PaginationParameters): void {
    void this.router.navigate([], {
      queryParams: {
        currentPage: paginationParams.currentPage,
        limit: paginationParams.limit,
        search: paginationParams.search,
      },
    });
  }
}
